<div class="modal-header" id="out-modal-title">
    <h3 class="modal-title" id="modal-title">OData structure for {{ label }}</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <pre>{{ model.getOutModel() | json }}</pre>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="modalInstance.hide()">Close</button>
</div>
